




































































































import Vue from "vue";
import { GetChangeDetailResponse } from "@/containers/changePlansSb/api";
import { defaultChangePlansData } from "@/components/AboutChangePlansSb/props";
import VcTextContainsLink from "@/components/TextContainsLink/TextContainsLink.vue";

type Props = {
  lang: any;
  isChangeDevice: boolean;
  isProToEx: boolean;
  isExToPro: boolean;
  isBillKonbiniPayment: boolean;
  isSpecialCreditPayment: boolean;
  urlGradeChange: string;
  urlDifferenceInGrade: string;
  urlHelpDifferenceAmount: string;
  urlHelpChangeFreeTrial: string;
  changePlansData: GetChangeDetailResponse;
  contractDetailLink: string;
};
type Data = {};
type Method = {
  existUpComingTotal: () => boolean;
};
type Computed = {};

export default Vue.extend<Data, Method, Computed, Props>({
  components: { VcTextContainsLink },
  props: {
    lang: {
      default: () => {}
    },
    isChangeDevice: { default: false },
    isProToEx: { default: false },
    isExToPro: { default: false },
    isBillKonbiniPayment: { default: false },
    isSpecialCreditPayment: { default: false },
    urlGradeChange: { default: "" },
    urlDifferenceInGrade: { default: "" },
    urlHelpDifferenceAmount: { default: "" },
    urlHelpChangeFreeTrial: { default: "" },
    changePlansData: {
      default: () => defaultChangePlansData
    },
    contractDetailLink: { default: "" }
  },
  methods: {
    existUpComingTotal() {
      return "upcomingTotal" in this.changePlansData;
    }
  }
});
